<template>
  <div>
   
    <Head title="Lista de precios" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/prices">Precios</Link>
      <span class="text-sky-400 font-medium">/</span> {{ nameListPrice }}
    </h1>
    <div class="flex items-center justify-between mb-6">
      <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <button class="btn-sky" @click="showDialog">Agregar producto</button>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">          
          <th class="pb-4 pt-6 px-2">Código</th>
          <th class="pb-4 pt-6 px-2">Producto</th>
          <th class="pb-4 pt-6 px-2">Unidad</th>
          <th class="pb-4 pt-6 px-2">Precio</th>          
        </tr>
        <tr v-for="product in products.data" :key="product.id" class="hover:bg-gray-100 focus-within:bg-gray-100"> 
          <td class="border-t">
            <span class="flex items-center px-6 py-4">
              {{ product.code }}
            </span>
          </td>         
          <td class="border-t">
            <span class="flex items-center px-6 py-4">
              {{ getProductDescription(product.id_producto) }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-6 py-4">
              {{ getTypeProductUnit(product.id_product_unit) }}
            </span>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4">
              $ {{ product.precio }}
            </Link>
          </td> 
          <td class="border-t">
            <button 
              class="focus:outline-none text-white bg-green-500 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-900"
              @click="showEditDialog(product)"
            >
              Editar precio venta
            </button>
          </td>
        </tr>
        <tr v-if="products.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">No se encontraron productos para esta lista de precios.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="products.links" />
  </div>
  <div>    
    <DialogInput v-if="showDialogInput" v-model="dialogValue" label="Nombre" :title="'Agregar producto a la lista'" @close="closeDialog">
      <div v-if="availableProducts.length !=0">
        <form class="w-full max-w-sm py-2" @submit.prevent="storeProducts">
          <div>
            <select-input v-model="form.product" :error="form.errors.product" class="py-2 w-full" label="Producto" @change="onProductChange">
              <option v-for="prod in availableProducts" :key="prod.id" :value="prod.id">{{ prod.producto }}</option>
            </select-input>
            
            <select-input v-model="form.price" :error="form.errors.price" class="py-2 w-full" label="Precio sugerido" @change="onSuggestedPriceChange">
              <option v-for="price in prices" :key="price.id" :value="price.id">Caja $ {{ price.price.toFixed(2) }} - Unitario $ {{ price.unit_price.toFixed(2) }}</option>
            </select-input>
            <text-input v-model="form.new_price" :error="form.errors.new_price" class=" w-full lg:w-3/3" label="Precio final" />         
          </div>
          <div class="flex items-center justify-center px-8 py-4">          
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear</loading-button>
          </div>        
        </form>
      </div>
      <div v-else>
        <p class="px-6 py-4 ">No hay más productos por agregar</p>
      </div>      
    </DialogInput>
  </div>
  <div>
    <!-- Dialog para editar precio -->
    <DialogInput 
      v-if="showEditDialogInput" 
      v-model="dialogValue" 
      label="Editar Precio" 
      title="Editar precio de venta" 
      @close="closeEditDialog"
    >
      <form class="w-full max-w-sm py-2" @submit.prevent="updatePrice">
        <div>
          <div class="mb-4">
            <p class="text-gray-700 font-medium">Producto: {{ selectedProduct.description }}</p>
            <p class="text-gray-600">Precio actual: $ {{ selectedProduct.precio }}</p>
          </div>
          
          <text-input 
            v-model="editForm.price" 
            :error="editForm.errors.price" 
            class="w-full" 
            label="Nuevo precio" 
          />
        </div>
        <div class="flex items-center justify-center px-8 py-4">
          <loading-button :loading="editForm.processing" class="btn-sky" type="submit">
            Actualizar
          </loading-button>
        </div>
      </form>
    </DialogInput>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import DialogInput from '@/Shared/Dialog'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Search from '@/Shared/Search'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'




export default {
  components: {
    Head,
    Link,
    DialogInput,
    LoadingButton,
    SelectInput,
    Search,
    Pagination,
    SearchFilter,
    TextInput,
    TextareaInput,
    
  },
  layout: Layout,
  props: {    
    products: Object,
    priceId: Number,
    availableProducts: Array,
    allProducts: Array,
    allPrices: Array,   
    filters: Object, 
    codes: Object, 
    families: Object,
    categories: Object,
    nameListPrice: String,
    typePrices: Array,
    productUnits: Array 
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        product: '',
        price: '',
        id_price: this.priceId,
        search: this.filters.search,
        code: this.filters.code,
        new_price:''

      }),
      dialogValue: '',
      showDialogInput: false, // Nuevo dato para controlar la visibilidad del diálogo
      prices : Array,
      editForm: this.$inertia.form({
        id: null,
        price: '',
      }),
      showEditDialogInput: false,
      selectedProduct: null,
    }
  },
  mounted() {
    window.addEventListener('load', () => {
      this.form.new_price = ''
      this.form.product = ''
      // Aquí puedes ejecutar el código que quieras cuando se recarga la página
    });
  },
  watch: {
      'form.price': function(newValue, oldValue) {
    this.form.new_price =Number(this.getPrice(this.form.price)).toFixed(2)
  }
  },
  methods: {
    reset() {
      //this.form = mapValues(this.form, () => null)
      this.form.product= ''
      this.form.price=''
      this.form.new_price=''
    },
    onProductChange(event) {
      const selectedProductId = event.target.value
      console.log(selectedProductId)
      console.log(this.allPrices)
      // Filtrar allPrices para obtener solo los elementos que coincidan con el product_id seleccionado
      const filteredPrices = this.allPrices.filter(price => price.product_id == selectedProductId)
      this.prices = filteredPrices
      console.log("Es:   ", filteredPrices)
    },
    onSuggestedPriceChange(event) {
      // const selectedPrice = event.target.value
      // console.log("Precio sugerido" +selectedPrice)
      // this.form.new_price = Number(selectedPrice).toFixed(2)
      
    },
    storeProducts() {
      // Utilizando async/await para esperar la respuesta del envío de datos
      (async () => {
        try {
          await this.$inertia.post('/pricesproducts', this.form)
          // Si la respuesta es exitosa, puedes agregar aquí cualquier lógica adicional
          this.closeDialog()
          this.reset()
        } catch (error) {
          console.error('Error al enviar datos:', error)
          // Puedes manejar el error aquí si es necesario
        }
      })()
    },      
   
    showDialog() {
      this.showDialogInput = true // Mostrar el diálogo al hacer clic en el botón
    },
    closeDialog() {
      this.showDialogInput = false // Cerrar el diálogo cuando se emite el evento 'close'
    },
    getProductDescription(number){
      const producto = this.allProducts.find(cat=> cat.id=== number)
      return producto ? producto.producto: 'Producto no disponible'
    },
    getPriceDescription(number){
      const precio = this.allPrices.find(cat=> cat.id=== number)
      return precio ? precio.price: 'precio no disponible'
    },
    getPrice(number){
      const precio = this.allPrices.find(cat=> cat.id=== number)
      return precio ? precio.price: 'precio no disponible'
    },
    getTypePrice(number){
      //allPrices
      const precio = this.typePrices.find(cat=> cat.id=== number)
      return precio ? precio.name: 'precio'
    },
    getTypeProductUnit(number){
      const productUnit = this.productUnits.find(obj=> obj.id=== number)
      return productUnit ? productUnit.description: 'Unidad'
    },
    showEditDialog(product) {
      this.selectedProduct = {
        id: product.id,
        description: this.getProductDescription(product.id_producto),
        precio: product.precio
      }
      this.editForm.id = product.id
      this.editForm.price = product.precio
      this.showEditDialogInput = true
    },

    closeEditDialog() {
      this.showEditDialogInput = false
      this.selectedProduct = null
      this.editForm.reset()
    },

    updatePrice() {
        this.editForm
            .put(`/prices/${this.editForm.id}`)
    },     
  },
  
}
</script>